module.exports = __webpack_public_path__ + "img/PE.ef9dac1d.svg";